import { eventsRequest } from '../../utils/eventsRequest';

interface SimpleOrderItem {
  id: number;
  item: {
    event: {
      id: number;
    };
  };
}

interface UsersApiResponse {
  id: number;
  email: string;
  children: {
    id: number;
    orderItems: SimpleOrderItem[];
  }[];
}

const getChildOrders = async (childId: number): Promise<{ eventIds: number[]; orderItems: SimpleOrderItem[] }> => {
  try {
    const response = await eventsRequest<UsersApiResponse>('/users', 'get');

    if (response.status === 200 || response.status === 201) {
      // Find the child in the response
      const child = response.data.children?.find(c => c.id === childId);

      if (!child || !child.orderItems) {
        return { eventIds: [], orderItems: [] };
      }
      
      // Extract and de-duplicate event IDs from order items
      const eventIds = Array.from(
        new Set(child.orderItems.map((orderItem) => orderItem.item.event.id))
      );

      // Also return the full order items so we can access pricing if available
      return { eventIds, orderItems: child.orderItems };
    }
    
    return { eventIds: [], orderItems: [] };
  } catch (error) {
    console.error('❌ Error fetching child orders:', error);
    return { eventIds: [], orderItems: [] };
  }
};

export default getChildOrders;

